import React from 'react'
import './Banner.css'
import { Button } from "@material-ui/core"
import { useHistory } from 'react-router-dom'

function BannerTerms () {

    const history = useHistory();

    return (
        <div className='banner'>
            <div className='banner__info'>
                <h1>Bienvenido a Ahavá !</h1>
                <h5>
                    Estás en la pantalla de los Términos y Condiciones. 
                    Para leer el Aviso de Privacidad, da click en el botón 
                    de abajo.
                </h5>
                <Button onClick={() => history.push('./privacy')}
                        variant='outlined'>
                        Leer el Aviso de Privacidad</Button>

                <Button onClick={() => history.push('./support')}
                        variant='outlined'>
                        Contactarme con Soporte</Button>
            </div>
        </div>
    )
}

export default BannerTerms
